// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_oIELK","trigger":"trigger_qU2DV","count":"count_E1yW6"};